import { SignalStoreBuilder } from "src/app/_stores/SignalStoreBuilder";
import { EmsPortalData } from "src/app/_models/location/EmsPortal";
import { EmsPortalDataDto } from "src/app/_models/location/LocationDTO";

type EmsPortalDataMap = { id_location: number; data: EmsPortalData[] };

export const SignalEmsPortalDataStore = new SignalStoreBuilder<EmsPortalDataMap>(
  (entry) => entry.id_location,
  (json) => {
    const id = json["id_location"] as number;
    const data = (json["data"] as unknown[]).map((d) =>
      EmsPortalData.fromDto(EmsPortalDataDto.fromJson(d)),
    );
    return { id_location: id, data };
  },
)
  .withMethod("loadAllLatest", (_store, http, { upsert }) => async () => {
    const response = await http.get("location/emsPortals/data", { hideLoader: true });
    if (!response) return;
    for (const item of response as any as {
      id_location: number;
      data: unknown;
    }[]) {
      if (!item.data) continue;
      const incoming = EmsPortalData.fromDto(EmsPortalDataDto.fromJson(item.data));
      const existing = _store.entityMap()[item.id_location]?.data ?? [];
      upsert({
        id_location: item.id_location,
        data: [incoming, ...existing.filter(d => d.id_ems_portal_data !== incoming.id_ems_portal_data)],
      });
    }
  })
  .withMethod(
    "loadData",
    (_store, http, { upsert }) =>
      async (id_location: number, limit: number = 120) => {
        const response = await http.get(
          `location/emsPortals/${id_location}/data?limit=${limit}`,
          { hideLoader: true },
        );
        if (!response) return;
        const data = (response["data"] as unknown[]).map((d) =>
          EmsPortalData.fromDto(EmsPortalDataDto.fromJson(d)),
        );
        upsert({ id_location, data });
      },
  )
  .withMethod(
    "loadLatest",
    (_store, http, { upsert }) =>
      async (id_location: number) => {
        const response = await http.get(
          `location/emsPortals/${id_location}/data?limit=1`,
          { hideLoader: true },
        );
        if (!response) return;
        const incoming = (response["data"] as unknown[]).map((d) =>
          EmsPortalData.fromDto(EmsPortalDataDto.fromJson(d)),
        );
        const existing = _store.entityMap()[id_location]?.data ?? [];
        const merged = [
          ...incoming,
          ...existing.filter(e => !incoming.some(i => i.id_ems_portal_data === e.id_ems_portal_data)),
        ];
        upsert({ id_location, data: merged });
      },
  )
  .withAutoRefresh((store) => store.loadAllLatest())
  .providedInRoot()
  .build();
